export const convertStoredToDisplayFormat = (content: string): string => {
  if (!content) return '';
  
  // First convert @[Name](urn:li:organization:123) format to styled spans
  let processedContent = content.replace(
    /@\[(.*?)\]\((urn:li:(organization|company):\d+)\)/g,
    '<span class="text-blue-600 font-bold" contenteditable="false" data-urn="$2">$1</span>'
  );

  // If the content doesn't already have HTML structure, add it
  if (!processedContent.includes('<div>')) {
    processedContent = processedContent
      .split('\n')
      .map(line => line.trim() ? `<div>${line}</div>` : '<div><br></div>')
      .join('');
  }

  return processedContent;
};

export const convertDisplayToStoredFormat = (content: string): string => {
  const container = document.createElement('div');
  container.innerHTML = content;
  
  // Convert span mentions to LinkedIn format
  const mentions = container.querySelectorAll('span[data-urn]');
  mentions.forEach(mention => {
    const name = mention.textContent;
    const urn = mention.getAttribute('data-urn');
    mention.replaceWith(`@[${name}](${urn})`);
  });
  
  return container.innerHTML;
};